<template>
  <v-navigation-drawer
    :value="isDialogOpen"
    temporary
    touchless
    :right="!$vuetify.rtl"
    :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
    app
    @input="val => $emit('update:is-dialog-open', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">Associar Integrante</span>

        <v-spacer></v-spacer>

        <v-btn
          icon
          small
          @click="$emit('update:is-dialog-open', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="formRef"
          @submit.prevent="handleSubmitBtnClick"
        >
          <v-autocomplete
            v-model="colaboradorSelecionado"
            class="mb-6"
            dense
            outlined
            label="Usuários"
            placeholder="Usuários"
            item-text="nome"
            item-value="id"
            return-object
            hide-details="auto"
            no-data-text="Nenhum usuário disponível"
            :loading="isGetAgentesNaoAssociadosLoading"
            :items="colaboradoresNaoAssociados"
            :rules="[validators.select]"
          />

          <v-btn
            color="primary"
            class="me-3 mb-1"
            type="submit"
          >
            <v-progress-circular
              v-if="loading"
              class="mx-6"
              indeterminate
              color="secundary"
            />

            <span v-else> Associar </span>
          </v-btn>

          <v-btn
            color="secondary"
            class="mb-1"
            outlined
            type="reset"
            @click="resetEquipeData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import { mdiClose } from '@mdi/js'
import router from '@/router'
import useForm from '@/composables/useForm'
import EquipeFuncaoEnum from '@/models/entities/equipe/EquipeFuncaoEnum'
import EquipeService from '@/services/modules/EquipeService'

export default {
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    funcao: {
      type: Number,
      default: 2,
    },
  },

  setup(props, { emit }) {
    const isCadastroAgente = computed(() => props.funcao === EquipeFuncaoEnum.Agente.id)

    const blankIntegranteData = {
      colaboradorId: 0,
      funcao: 0,
    }
    const colaboradorSelecionado = ref(JSON.parse(JSON.stringify(blankIntegranteData)))

    const colaboradoresNaoAssociados = ref([])
    const isGetAgentesNaoAssociadosLoading = ref(false)
    const { formRef, loading, resetForm, validateForm } = useForm()

    async function getColaboradoresNaoAssociados() {
      if (isGetAgentesNaoAssociadosLoading.value) return

      try {
        isGetAgentesNaoAssociadosLoading.value = true
        colaboradoresNaoAssociados.value = await EquipeService.getAgentesNaoAssociados(router.currentRoute.params.id)
      } finally {
        isGetAgentesNaoAssociadosLoading.value = false
      }
    }

    watch(
      () => props.isDialogOpen,
      v => {
        if (!v) return
        getColaboradoresNaoAssociados()
      },
    )

    function resetEquipeData() {
      colaboradorSelecionado.value = JSON.parse(JSON.stringify(blankIntegranteData))
      resetForm()
      setTimeout(() => {
        emit('update:is-dialog-open', false)
      }, 2000)
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return
      if (!validateForm()) return

      const data = {
        colaboradorId: colaboradorSelecionado.value.id,
        funcaoId: props.funcao,
      }

      try {
        loading.value = true
        await EquipeService.associarEquipeEAgente(router.currentRoute.params.id, data)
        emit('refetch-data')
        resetEquipeData()
      } finally {
        loading.value = false
      }
    }

    return {
      isCadastroAgente,
      formRef,
      loading,
      colaboradorSelecionado,
      colaboradoresNaoAssociados,
      isGetAgentesNaoAssociadosLoading,

      resetEquipeData,
      handleSubmitBtnClick,

      validators: {
        required,
        select,
      },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
